import React, { useEffect, useState, useRef } from "react";
import { Container } from "components";
import api from "services/api";
import { RELATIONS, KYC } from "services/api.config";
import moment from "moment";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const KYCDocumantation = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [relations, setRelations] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [kycData, setKycData] = useState([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const user = location.state?.user || "";
  const applicationId = location?.state?.applicationId;
  console.log("applicationId", applicationId);
  console.log("user:", user);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const initialValues = {
    aadhar_document: "",
    pan_document: "",
    user_image: "",
    relation: user ? user : "",
    aadhar_number: "",
    bank_acc_number: "",
    bank_ifsc: "",
  };

  const inputFileRef = useRef();
  const adherRef = useRef();

  const validationSchema = Yup.object({
    relation: Yup.string().required("Required"),
    pan_document: Yup.string(),
    user_image: Yup.string().required("Required"),
    aadhar_document: Yup.string().required("Required"),
    // aadhar_number: Yup.number().required("Required").min(12,"Aadhaar number must type 12 digits")
    // .max(12,"Aadhaar number dont allow grater then  12 digits") ,
    aadhar_number: Yup.string()
      .required("Required")
      .matches(
        /^[0-9]{12}$/,
        "Aadhaar number must be exactly 12 numeric characters"
      ),
    bank_acc_number: Yup.string()
      .matches(/^[0-9]*$/, "Only numeric characters")
      .min(8, "Minimum 8 digits")
      .max(16, "maximum 16 digits")
      .test(
        "acc-ifsc-required",
        "Account number is required when IFSC code is provided",
        function (value) {
          const { bank_ifsc } = this.parent;
          if (bank_ifsc && bank_ifsc.trim().length > 0) {
            return value && value.trim().length > 0;
          }
          return true; // if IFSC is empty, no need for account number
        }
      ),

    bank_ifsc: Yup.string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code")
      .when("bank_acc_number", {
        is: (val) => val && val.trim().length > 0,
        then: (schema) =>
          schema.required(
            "IFSC code is required when account number is provided"
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const fetchKycData = async () => {
    try {
      const response = await api.get(KYC);
      setKycData(response.data.data.kyc);
      console.log("kyc:", response.data.data.kyc);
    } catch (error) {
      console.log("fetchKycData error:", error);
    }
  };

  const fetchRelaction = async () => {
    try {
      const response = await api.get(RELATIONS);
      setRelations(response.data.data.relations);
    } catch (error) {
      console.log("relation error:", error);
    }
  };

  // Fetch relations on component mount
  useEffect(() => {
    fetchRelaction();
    fetchKycData();
  }, []);

  // Handle file input change for document file
  const handleDocumentFileChange = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const fileSize = 800 * 1024;
    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        e.target.value = null;
        return;
      }
      if (file.size > fileSize) {
        toast.error("File size should not exceed 2KB.");
        e.target.value = null;
        return;
      }
    }
    setFieldValue("aadhar_document", e.target.files[0]);
  };
  const handlePanDocumentFileChange = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const fileSize = 800 * 1024;
    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        e.target.value = null;
        return;
      }
      if (file.size > fileSize) {
        toast.error("File size should not exceed 2KB.");
        e.target.value = null;
        return;
      }
    }
    setFieldValue("pan_document", e.target.files[0]);
  };
  const handleDocumentNumberChange = (e, setFieldValue) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Za-z0-9]*$/.test(value)) {
      setFieldValue("aadhar_number", value);
    }
  };
  const handleAccountNumberChange = (e, setFieldValue) => {
    const value = e.target.value.toUpperCase();
    if (/^[0-9]*$/.test(value)) {
      setFieldValue("bank_acc_number", value);
    }
  };
  const handleIfscNumberChange = (e, setFieldValue) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Za-z0-9]*$/.test(value)) {
      setFieldValue("bank_ifsc", value);
    }
  };
  // Handle file input change for image file
  const handleImageChange = (e, setFieldValue) => {
    const file = e.target.files[0];
    console.log("image:", file);
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const fileSize = 800 * 1024;

    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        return;
      }
      if (file.size > fileSize) {
        toast.error("File size should not exceed 800KB.");
        return;
      }
    }
    setSelectedImage(URL.createObjectURL(file));
    setFieldValue("user_image", file);
  };

  // Trigger file input click
  const triggerFileInput = () => {
    console.log("callingg");
    document.getElementById("upload").click();
  };

  // Reset selected image and files
  const handleResetImage = (setFieldValue) => {
    setSelectedImage(null);
    setFieldValue("user_image", "");
    inputFileRef.current.value = "";
  };

  // Handle form submission
  const handleSubmit = async (values, resetForm) => {
    setLoader(true);
    const formData = new FormData();

    if (values.pan_document) {
      formData.append("pan_document", values.pan_document);
    }
    formData.append("relation", values.relation);
    // formData.append("pan_document", values.pan_document);
    formData.append("user_image", values.user_image);
    formData.append("aadhar_document", values.aadhar_document);
    formData.append("aadhar_number", values.aadhar_number);
    formData.append("bank_acc_number", values.bank_acc_number);
    formData.append("bank_ifsc", values.bank_ifsc);
    formData.append("application_id", applicationId);
    api
      .post(KYC, formData)
      .then((res) => {
        console.log("resKYC:", res);
        setSelectedImage(null);
        inputFileRef.current.value = null;
        adherRef.current.value = null;
        toast.success(res?.data?.message);
        setLoader(false);
        resetForm();
        fetchKycData();
        setFormSubmitted(true);
      })

      .catch((err) => {
        console.log("Submit error:", err);

        const errorData = err?.response?.data?.errors;
        let errors = [];

        if (typeof errorData === "object" && errorData !== null) {
          errors = Object.values(errorData).flat(); // Flatten all arrays of error messages
        } else if (typeof errorData === "string") {
          errors = [errorData];
        }

        errors.forEach((error) => toast.error(error));

        setLoader(false);
      });
  };

  const handleViewModel = (entry) => {
    setModalData(entry);
    setViewOpen(true);
  };
  const closeModel = () => {
    setModalData(null);
    setViewOpen(false);
  };

  const handleCancelClick = () => {
    inputFileRef.current.value = null;
    adherRef.current.value = null;
    setSelectedImage(null);
  };
  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          {user && !formSubmitted && (
            <div className="card mb-4">
              <h5 className="card-header">
                Please provide Aadhaar Card which is linked with PAN to avoid
                TDS deduction
              </h5>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm }) => {
                  handleSubmit(values, resetForm);
                }}
              >
                {({
                  setFieldValue,
                  errors,
                  resetForm,
                  values,
                  setFieldError,
                }) => (
                  <>
                    <input
                      type="file"
                      id="upload"
                      name="user_image"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, setFieldValue)}
                      required
                      ref={inputFileRef}
                      value={""}
                    />
                    <Form>
                      <div className="card-body">
                        <div className="d-flex align-items-start align-items-sm-center gap-4">
                          <img
                            src={
                              selectedImage || "../../assets/img/avatars/14.jpg"
                            }
                            alt="user-avatar"
                            className="d-block w-px-100 h-px-100 rounded"
                            id="uploadedAvatar"
                          />
                          <div className="button-wrapper">
                            <button
                              className="btn btn-primary me-2 mb-3"
                              onClick={triggerFileInput}
                              type="button"
                            >
                              <span className=" d-sm-block">Upload photo</span>
                            </button>

                            <button
                              type="button"
                              className="btn btn-label-secondary account-image-reset mb-3"
                              onClick={() => handleResetImage(setFieldValue)}
                            >
                              <i className="ti ti-refresh-dot d-block d-sm-none"></i>
                              <span className="d-none d-sm-block">Reset</span>
                            </button>
                            <div className="text-muted">
                              <span className="invalid-form">*</span> Allowed
                              JPG, GIF or PNG. Max size of 800 KB (This is used
                              for zenosure card.)
                            </div>
                          </div>
                        </div>
                        <ErrorMessage
                          name="user_image"
                          component="div"
                          className="invalid-form"
                        />
                      </div>
                      <hr className="my-0" />
                      <div className="card-body">
                        <div className="row">
                          <div className="mb-3 col-md-4">
                            <label
                              htmlFor="documentType"
                              className="form-label"
                            >
                              Aadhaar upload{" "}
                              <span className="invalid-form">*</span>
                            </label>
                            <input
                              name="collapsible-payment"
                              className="form-control"
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleDocumentFileChange(
                                  e,
                                  setFieldValue,
                                  setFieldError
                                )
                              }
                              ref={adherRef}
                            />
                            <ErrorMessage
                              name="aadhar_document"
                              component="div"
                              className="invalid-form"
                            />
                          </div>
                          <div className="mb-3 col-md-4">
                            <label
                              htmlFor="documentType"
                              className="form-label"
                            >
                              Pan upload
                            </label>
                            <input
                              name="collapsible-payment"
                              className="form-control"
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handlePanDocumentFileChange(e, setFieldValue)
                              }
                              ref={inputFileRef}
                            />
                            <small className="text-muted">
                              If PAN card is not provided, 20 percent TDS will
                              apply
                            </small>
                          </div>
                          <div className="mb-3 col-md-4">
                            <label htmlFor="relation" className="form-label">
                              Select relation{" "}
                              <span className="invalid-form">*</span>
                            </label>
                            <Field
                              as="select"
                              className="select2 form-select"
                              name="relation"
                              disabled={!!user} // Disable field if user exists
                            >
                              <option value="">Select</option>
                              {relations.map((relation, index) => (
                                <option key={index} value={relation}>
                                  {relation}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="relation"
                              component="div"
                              className="invalid-form"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-md-4">
                            <label
                              htmlFor="documentType"
                              className="form-label"
                            >
                              Aadhaar number{" "}
                              <span className="invalid-form">*</span>
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="aadhar_number"
                              onChange={(e) => {
                                const input = e.target.value;
                                if (/^\d*$/.test(input)) {
                                  handleDocumentNumberChange(e, setFieldValue);
                                  console.log("aadhar-number changed:", input);
                                }
                              }}
                              maxLength="12"
                              placeholder="Aadhaar Number"
                            />
                            <ErrorMessage
                              name="aadhar_number"
                              component="div"
                              className="invalid-form"
                            />
                          </div>
                          <div className="mb-3 col-md-4">
                            <label
                              htmlFor="documentType"
                              className="form-label"
                            >
                              Bank account number
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="bank_acc_number"
                              placeholder="Bank account number"
                              onChange={(e) => {
                                handleAccountNumberChange(e, setFieldValue);
                              }}
                              maxLength="16"
                              minLength="8"
                            />
                            <ErrorMessage
                              name="bank_acc_number"
                              component="div"
                              className="invalid-form"
                            />
                          </div>
                          <div className="mb-3 col-md-4">
                            <label
                              htmlFor="documentType"
                              className="form-label"
                            >
                              IFSC
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="bank_ifsc"
                              onChange={(e) => {
                                handleIfscNumberChange(e, setFieldValue);
                                console.log(
                                  "bank_ifsc changed:",
                                  e.target.value
                                );
                              }}
                              maxLength="11"
                              placeholder="IFSC"
                            />
                            <ErrorMessage
                              name="bank_ifsc"
                              component="div"
                              className="invalid-form"
                            />
                          </div>
                        </div>

                        <div className="mt-2">
                          {loader ? (
                            <button
                              type="button"
                              className="spinner-border text-primary"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary me-2"
                            >
                              Save changes
                            </button>
                          )}

                          <button
                            type="reset"
                            className="btn btn-label-secondary"
                            onClick={handleCancelClick}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
              <hr className="my-0" />
            </div>
          )}
          <div className="card-datatable table-responsive">
            <table className="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
              <thead>
                <tr>
                  <th>Profile</th>
                  <th className="text-truncate">Relation</th>
                  <th>Aadhaar Number</th>
                  <th>Application Number</th>
                  <th>Submitted on </th>
                  <th className="text-truncate">Verified on</th>
                  <th className="text-truncate">KYC Status</th>
                  <th className="cell-fit">Aadhaar</th>
                  <th className="cell-fit">Pan</th>
                </tr>
              </thead>
              <tbody>
                {kycData?.map((entry, index) => (
                  <tr key={index}>
                    <td>
                      {
                        <img
                          src={entry.user_image}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                          }}
                        />
                      }
                    </td>
                    <td>{entry.relation}</td>
                    <td>{entry?.aadhar_number}</td>
                    <td
                      onClick={() =>
                        navigate(`/membershipDetails/${entry.application_no}`)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {entry?.application_no}
                    </td>
                    <td>{moment(entry.created_at).format("DD-MM-YYYY")}</td>
                    <td>
                      {entry.verified_at
                        ? moment(entry.verified_at).format("DD-MM-YYYY")
                        : "Not Verified"}
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          entry.status === "Pending"
                            ? "bg-warning"
                            : entry.status === "Approved"
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {entry.status}
                      </span>
                    </td>
                    <td className="text-center">
                      {entry.aadhar_document_url ? (
                        <button
                          variant="outlined"
                          className="btn btn-primary"
                          onClick={() =>
                            handleViewModel(entry.aadhar_document_url)
                          }
                        >
                          View
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="text-center">
                      {entry.pan_document_url ? (
                        <button
                          variant="outlined"
                          className="btn btn-primary"
                          onClick={() =>
                            handleViewModel(entry.pan_document_url)
                          }
                        >
                          View
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {viewOpen && modalData && (
            <div
              className="modal fade show"
              style={{ display: "block" }}
              tabIndex="-1"
              area-moda="true"
              role="dialog"
            >
              <div className="modal-dialog " role="document">
                <div className="modal-content text-center">
                  <div className="modal-header border-0">
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={closeModel}
                    ></button>
                  </div>
                  <div className="modal-body ">
                    {modalData.endsWith(".pdf") ? (
                      <iframe
                        src={modalData}
                        title="aadhar_document"
                        width="100%"
                        height="500px"
                      ></iframe>
                    ) : (
                      <div className="onboarding-media">
                        <img
                          src={modalData}
                          alt="aadhar"
                          width="335"
                          className="img-fluid"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* <div class="toast-container">
         
          </div> */}
        </div>
      </div>
    </Container>
  );
};

export default KYCDocumantation;
